import { RouterModule } from '@angular/router'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsiteFooterComponent } from './website-footer.component'
import { DesktopSitemapMenuComponent } from './desktop-sitemap-menu/desktop-sitemap-menu.component'
import { MobileSitemapMenuComponent } from './mobile-sitemap-menu/mobile-sitemap-menu.component'
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap'
import { SharedModule } from '../shared/shared.module'
import { PipesModule } from "../../pipes/pipes.module";


@NgModule({
  declarations: [WebsiteFooterComponent, DesktopSitemapMenuComponent, MobileSitemapMenuComponent],
  imports: [
    CommonModule,
    RouterModule,
    NgbCollapseModule,
    SharedModule,
    PipesModule
  ],
  exports: [WebsiteFooterComponent]
})
export class WebsiteFooterModule { }
